import { createTheme } from '@mui/material/styles';

// Create a custom theme for WatchPassion platform
const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#951520', // Rosso WatchPassion
      light: '#b54450',
      dark: '#6e0e17',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#ff6b00', // Orange
      light: '#ff9a47',
      dark: '#c53d00',
      contrastText: '#ffffff',
    },
    background: {
      default: '#f8f9fa',
      paper: '#ffffff',
    },
    error: {
      main: '#d32f2f',
    },
    warning: {
      main: '#ffa726',
    },
    info: {
      main: '#29b6f6',
    },
    success: {
      main: '#66bb6a',
    },
    text: {
      primary: '#212121',
      secondary: '#757575',
    },
  },
  typography: {
    fontFamily: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
    },
    h2: {
      fontWeight: 600,
    },
    h3: {
      fontWeight: 600,
    },
    h4: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 500,
    },
    h6: {
      fontWeight: 500,
    },
    button: {
      fontWeight: 500,
      textTransform: 'none',
    },
  },
  shape: {
    borderRadius: 8,
  },
  shadows: [
    'none',
    '0px 2px 1px -1px rgba(0,0,0,0.05),0px 1px 1px 0px rgba(0,0,0,0.03),0px 1px 3px 0px rgba(0,0,0,0.05)',
    '0px 3px 3px -2px rgba(0,0,0,0.06),0px 3px 4px 0px rgba(0,0,0,0.04),0px 1px 8px 0px rgba(0,0,0,0.06)',
    '0px 3px 5px -1px rgba(0,0,0,0.06),0px 6px 10px 0px rgba(0,0,0,0.04),0px 1px 18px 0px rgba(0,0,0,0.06)',
    '0px 4px 5px -2px rgba(0,0,0,0.06),0px 7px 10px 1px rgba(0,0,0,0.04),0px 2px 16px 1px rgba(0,0,0,0.06)',
    '0px 5px 5px -3px rgba(0,0,0,0.06),0px 8px 10px 1px rgba(0,0,0,0.04),0px 3px 14px 2px rgba(0,0,0,0.06)',
    '0px 6px 6px -3px rgba(0,0,0,0.06),0px 10px 14px 1px rgba(0,0,0,0.04),0px 4px 18px 3px rgba(0,0,0,0.06)',
    '0px 7px 8px -4px rgba(0,0,0,0.06),0px 12px 17px 2px rgba(0,0,0,0.04),0px 5px 22px 4px rgba(0,0,0,0.06)',
    '0px 8px 9px -5px rgba(0,0,0,0.06),0px 15px 22px 2px rgba(0,0,0,0.04),0px 6px 28px 5px rgba(0,0,0,0.06)',
    '0px 9px 11px -5px rgba(0,0,0,0.06),0px 18px 28px 2px rgba(0,0,0,0.04),0px 7px 34px 6px rgba(0,0,0,0.06)',
    '0px 10px 13px -6px rgba(0,0,0,0.06),0px 20px 31px 3px rgba(0,0,0,0.04),0px 8px 38px 7px rgba(0,0,0,0.06)',
    '0px 11px 14px -7px rgba(0,0,0,0.06),0px 23px 36px 3px rgba(0,0,0,0.04),0px 9px 44px 8px rgba(0,0,0,0.06)',
    '0px 12px 16px -7px rgba(0,0,0,0.06),0px 25px 40px 4px rgba(0,0,0,0.04),0px 10px 48px 9px rgba(0,0,0,0.06)',
    '0px 13px 19px -7px rgba(0,0,0,0.06),0px 28px 44px 4px rgba(0,0,0,0.04),0px 11px 52px 10px rgba(0,0,0,0.06)',
    '0px 14px 21px -7px rgba(0,0,0,0.06),0px 32px 48px 5px rgba(0,0,0,0.04),0px 12px 56px 10px rgba(0,0,0,0.06)',
    '0px 15px 22px -7px rgba(0,0,0,0.06),0px 36px 52px 5px rgba(0,0,0,0.04),0px 13px 60px 10px rgba(0,0,0,0.06)',
    '0px 16px 24px -7px rgba(0,0,0,0.06),0px 40px 56px 6px rgba(0,0,0,0.04),0px 14px 64px 10px rgba(0,0,0,0.06)',
    '0px 17px 26px -7px rgba(0,0,0,0.06),0px 44px 60px 6px rgba(0,0,0,0.04),0px 15px 68px 10px rgba(0,0,0,0.06)',
    '0px 18px 28px -7px rgba(0,0,0,0.06),0px 48px 64px 7px rgba(0,0,0,0.04),0px 16px 72px 10px rgba(0,0,0,0.06)',
    '0px 19px 29px -7px rgba(0,0,0,0.06),0px 52px 68px 7px rgba(0,0,0,0.04),0px 17px 76px 10px rgba(0,0,0,0.06)',
    '0px 20px 31px -7px rgba(0,0,0,0.06),0px 56px 72px 8px rgba(0,0,0,0.04),0px 18px 80px 10px rgba(0,0,0,0.06)',
    '0px 21px 33px -7px rgba(0,0,0,0.06),0px 60px 76px 8px rgba(0,0,0,0.04),0px 19px 84px 10px rgba(0,0,0,0.06)',
    '0px 22px 35px -7px rgba(0,0,0,0.06),0px 64px 80px 9px rgba(0,0,0,0.04),0px 20px 88px 10px rgba(0,0,0,0.06)',
    '0px 23px 36px -7px rgba(0,0,0,0.06),0px 68px 84px 9px rgba(0,0,0,0.04),0px 21px 92px 10px rgba(0,0,0,0.06)',
    '0px 24px 38px -7px rgba(0,0,0,0.06),0px 72px 88px 10px rgba(0,0,0,0.04),0px 22px 96px 10px rgba(0,0,0,0.06)',
  ],
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '10px 24px',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
          },
        },
        contained: {
          '&:hover': {
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        rounded: {
          borderRadius: 12,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: '0px 1px 10px rgba(0, 0, 0, 0.05)',
        },
      },
    },
  },
});

export default theme;
